export const getItemPlaceholderBoxViewStyle = (components, { palette = {} } = {}) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  mainViewContainer: {
    width: '100%',
    background: 'rgb(0,0,0, 0.8)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexGrow: 1,
  },
  mainViewContentContainer: {
    height: 41,
    width: 80,
    background: 'rgb(50,49,48, 0.6)',
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',

    '& $mainViewIconLabelContainer': {
      color: palette.white,
      marginLeft: 6,
    },
  },
  mainViewIconLabelContainer: {}, // required otherwise nested classnames will not work
  contentIcon: {
    width: 25,
  },

  footerContainer: {
    background: '#2F2F2F',
    display: 'flex',
    height: 48,
    padding: 10,
    alignItems: 'center',
    lineHeight: '21px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',

    '&$footerInvalid': {
      background: '#FFF4CE',

      '& $footerContent': {
        color: palette.black,
      },
    },
  },
  footerInvalid: {}, // required otherwise nested classnames will not work
  footerContent: {
    color: palette.white,
    display: 'flex',
    marginLeft: 8,
    alignItems: 'center',
  },
});
